export default {
  banner: [
    `<span class="font-black">Painel Gerencial:</span>`,
    'Melhorando a Gestão e <br> Visualização de Dados',
    'A solução para visualizar, compartilhar e <br>impulsionar resultados',
  ],
}
